import { render, staticRenderFns } from "./CustomerRequest.vue?vue&type=template&id=b155fa2a&scoped=true&"
import script from "./CustomerRequest.vue?vue&type=script&lang=js&"
export * from "./CustomerRequest.vue?vue&type=script&lang=js&"
import style0 from "./CustomerRequest.vue?vue&type=style&index=0&id=b155fa2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b155fa2a",
  null
  
)

export default component.exports